// extracted by mini-css-extract-plugin
export var dropdownContainer = "_r0-0";
export var leftAlign = "_r0-4";
export var listItem = "_r0-2";
export var listItemWrapper = "_r0-1";
export var operationText = "_r0-3";